var React = require('react');

function Betamax (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 160v240a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V160zm144 224a80 80 0 1 1 80-80 80 80 0 0 1-80 80zm304 0H288V224h160z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M496 64H16A16 16 0 0 0 0 80v80h512V80a16 16 0 0 0-16-16zM144 224a80 80 0 1 0 80 80 80 80 0 0 0-80-80zm0 112a32 32 0 1 1 32-32 32 32 0 0 1-32 32z","className":"fa-primary","key":2})]);
}

Betamax.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Betamax;

Betamax.default = Betamax;
